package gr.tech.GRAttestation.infrastructure.api

import gr.tech.GRAttestation.infrastructure.session.StoreUserSession
import gr.tech.GRAttestation.models.api.ApiError
import gr.tech.GRAttestation.models.api.ApiResponse
import gr.tech.GRAttestation.models.storeusers.StoreUserFinishRegistrationRequest
import gr.tech.GRAttestation.models.storeusers.StoreUsersDTO
import gr.tech.GRAttestation.models.user.auth.PasswordResetModel
import gr.tech.GRAttestation.models.user.auth.UserLoginModel
import gr.tech.GRAttestation.navigation.SitePage
import gr.tech.GRAttestation.util.ROUTES
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json
import org.w3c.fetch.INCLUDE
import org.w3c.fetch.RequestCredentials
import org.w3c.fetch.RequestInit

suspend fun checkStoreUserJWT(redirectLogin: Boolean = true, redirectTo: String = SitePage.Login.route): ApiResponse<StoreUsersDTO> {
    return safeApiCallStringBody(
        url = ROUTES.BACKEND.AUTH.STORE_USER_CHECK_AUTH,
        redirectLogin = redirectLogin,
        redirectTo = redirectTo
    )
}

suspend fun storeUserLoginWithCredentials(
    credentials: UserLoginModel,
): ApiResponse<String> {
    return safeApiCallStringBody(
        url = ROUTES.BACKEND.AUTH.STORE_USER_CRED_LOGIN,
        method = "POST",
        body = Json.encodeToString(credentials),
        redirectLogin = false
    )
}

suspend fun storeUserLogout() {
    window.fetch(ROUTES.BACKEND.AUTH.STORE_USER_SIGN_OUT, RequestInit(method = "POST", credentials = RequestCredentials.INCLUDE)).await()
    StoreUserSession.setLoggedOut()
    window.location.href = SitePage.Login.route
}

suspend fun userGetResetPasswordEmail(email: String): ApiResponse<String> {
    return safeApiCallStringBody(
        url = ROUTES.BACKEND.AUTH.STORE_USER_RESET_PASSWORD_EMAIL,
        method = "POST",
        redirectLogin = false,
        body = Json.encodeToString(email)
    )
}

suspend fun checkUserResetToken(token: String): ApiResponse<String> {
    return safeApiCallStringBody(
        url = "${ROUTES.BACKEND.AUTH.STORE_USER_RESET_TOKEN_CHECK}?token=$token",
        method = "GET",
        redirectLogin = false,
    )
}

suspend fun userResetPassword(model: PasswordResetModel): ApiResponse<String> {
    return safeApiCallStringBody(
        url = ROUTES.BACKEND.AUTH.STORE_USER_RESET_PASSWORD,
        method = "POST",
        body = Json.encodeToString(model),
        redirectLogin = false
    )
}

// Finish Registration Stuff
// REGISTRATION
suspend fun checkStoreUserRegisterToken(token: String): ApiResponse<String> {
    return safeApiCallStringBody(
        url = "${ROUTES.BACKEND.AUTH.STORE_USER_REGISTER_TOKEN_CHECK}?token=$token",
        method = "GET",
        redirectLogin = false,
    )
}

suspend fun finishStoreUserRegister(storeUser: StoreUserFinishRegistrationRequest): ApiResponse<String> {
    return safeApiCallStringBody(
        url = ROUTES.BACKEND.AUTH.STORE_USER_REGISTER_FINISH,
        method = "POST",
        redirectLogin = false,
        body = Json.encodeToString(storeUser)
    )
}